// @ts-nocheck
/* eslint-disable */
import SceneMarker from "./marker";

export default class SceneMarkerPano extends SceneMarker {
	/**
	 * Vytvoreni pano markeru - dle API.
	 *
	 * @param  {SceneCoords} coords Souradnice
	 * @param  {Number|String} [id] Volitelne ID
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords?, id?, opts?) {
		super(scene, itemId, coords, id, opts);

		this._angle = 0;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerPano",
			type: "marker",

		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		let rd = super.getCreateData();

		rd.angle = this._angle;

		return rd;
	}

	/**
	 * Nastaveni novych souradnic.
	 *
	 * @param {SceneCoords} coords Nove souradnice
	 */
	setCoords(coords) {
		this._coords = coords;

		this._scene.makeEvent("marker-change", null, this);

		this._onChange(this._scene.featureEvent("markerSetCoords", true, true), arguments);
	}

	/**
	 * Nastaveni noveho uhlu markeru.
	 *
	 * @param {Number} angle Uhel ve stupnich
	 */
	setAngle(angle) {
		this._angle = angle;

		this._onChange(this._scene.featureEvent("markerPanoSetAngle", true, true), arguments);
	}

	/**
	 * Ziskani uhlu otoceni ve stupnich.
	 *
	 * @return {Number}
	 */
	getYaw() {
		return (this._angle / 180 * Math.PI);
	}
}
